import { render, staticRenderFns } from "./PosterResourcesBox.vue?vue&type=template&id=24009fb2&scoped=true&"
import script from "./PosterResourcesBox.vue?vue&type=script&lang=ts&"
export * from "./PosterResourcesBox.vue?vue&type=script&lang=ts&"
import style0 from "./PosterResourcesBox.vue?vue&type=style&index=0&id=24009fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24009fb2",
  null
  
)

export default component.exports